import { Typography } from "@mui/material";
import { Trans } from "@lingui/macro";
import { getCopyrightYearSuffix } from "@WahooFitness/wahoo-offline-mfe";

function Copyright() {
  const toCurrentYear = getCopyrightYearSuffix(2023);

  return (
    <Typography color="text.secondary" variant="ui-2xs">
      <Trans>© 2023{toCurrentYear} Wahoo Fitness L.L.C. All Rights Reserved.</Trans>
    </Typography>
  );
}

export default Copyright;
